module.exports = __webpack_public_path__ + "img/logo.96387ce8.png";